import Styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const AppMigrationContainer = Styled.p`
  padding: 15px 20px;
  box-sizing: border-box;
  text-align: center;
  color: ${COLORS.textGrey};
  display: block;
  line-height: 21px;
  & span {
    font-family: ${FONT_FAMILY.default.bold};
    color: ${COLORS.black};
  }
`;

export const AppMigrationModal = Styled.div`
width: 542px;
background-color: ${COLORS.white};
padding: 60px 25px;
box-sizing: border-box;
position: relative;
border-radius: 10px;
text-align: center;
& .close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
& h1{
  font-size: 28px;
  color: ${COLORS.black}
}
& p {
  color: ${COLORS.textGrey};
  line-height: 21px;
}
& .margin-vertical{
  margin-top: 10px;
  margin-bottom: 20px;
}
& .instarem-qrcode{
  width: 137px;
  height: 137px;
  float: none;
  margin-top: 20px;
}
& .highlight-fee{
  font-family: ${FONT_FAMILY.default.bold};
}
& .center-btn{
  margin: 0 auto;
}
& .add-margin-top{
  margin-top: 20px;
}
`;

export const AppMigrationFlagWrapper = Styled.div`
  position: absolute;
  left: -10px;
  top: -10px;
  z-index: 2;
  background-color: ${COLORS.brandPurple};
  color: ${COLORS.white};
  font-family: ${FONT_FAMILY.default.bold};
  padding: 5px;
  font-size: 14px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  &::before {
    content: "";
    width: 0;
    height: 0;
    border-top: 10px solid #5220B3;
    border-left: 10px solid transparent;
    position: absolute;
    top: 100%;
    left: 0;
  }
`;

export const FeesWrapper = Styled('div')`
  text-align: center;
  @media screen and (min-width: 450px) {
  br {
      display : none
  }
}
`;
